var React = require('react');

function Open (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#020303","clipPath":"url(#open1)","key":0},[React.createElement("path",{"d":"M2.498 16.001h10.996A2.51 2.51 0 0 0 16 13.494V2.479A2.491 2.491 0 0 0 13.512-.01H8.267v1.124h5.245c.753 0 1.366.612 1.366 1.365v11.017c0 .762-.62 1.384-1.384 1.384H2.496c-.763 0-1.384-.62-1.384-1.384V8.267H-.012v5.227A2.512 2.512 0 0 0 2.498 16ZM0 4.68h1.123V1.124H4.68V-.001H-.001v4.682Z","key":0}),React.createElement("path",{"d":"M.948.154.154.95l7.428 7.428.795-.794L.948.154Z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"open1"},React.createElement("path",{"fill":"#fff","d":"M16 0H0v16h16z"})))]);
}

Open.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = Open;

Open.default = Open;
